import { useEffect, useState } from "react";
import { SelectorComparisonOperator } from "../Components/SelectorComparisonOperator";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { CRSelectorConstants } from "../../../../bpm/config/Componentes/CRSelectorConstants";
import { DepartamentCitiesEditor } from "../../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/Components/DepartamentCitiesEditor";

interface addCondition {
    Prop: any;
    Value: any;
    renderValue: string;
    Operator: string;
}

interface Props {
    jsonProps: string;
    onChange: Function;
}

export const ListPropsParameters = ({ jsonProps, onChange }: Props) => {

    const [format, setFortmat] = useState<Partial<addCondition>>({});
    const [lista, setLista] = useState([]);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        try {
            if (jsonProps && jsonProps.trim() !== "") {
                const parsed = JSON.parse(jsonProps);
                if (Array.isArray(parsed)) {
                    setLista(parsed);
                } else {
                    toast.error("El formato de jsonProps no es una lista válida.");
                    setLista([]);
                }
            } else {
                setLista([]);
            }
        } catch (error) {
            toast.error("Error al parsear jsonProps.");
            setLista([]);
        }
    };


    const create = () => {
        if (!format.Prop || !format.Value || !format.Operator) {
            toast.error("Los campos Propiedad, Valor y Operador son obligatorios");
            return;
        }

        const alreadyExists = lista.some(item => item.Prop?.PropertyValue === format.Prop.PropertyValue);

        if (alreadyExists) {
            toast.warning("La propiedad ya fue seleccionada. No se puede agregar duplicada.");
            return;
        }

        setLista([...lista, format as addCondition]);

        setFortmat({
            Prop: "",
            Value: "",
            renderValue: "",
            Operator: "",
        });
    };


    const deleteItem = (index: number) => {
        const nuevaLista = lista.filter((_, i) => i !== index);
        setLista(nuevaLista);
    };

    useEffect(() => {
        if (onChange) {
            onChange(JSON.stringify(lista))
        }
    }, [lista])

    const operators = [
        { descripcion: "Igual a", valor: "=" },
        { descripcion: "Distinto de", valor: "!=" },
        { descripcion: "Mayor que", valor: ">" },
        { descripcion: "Menor que", valor: "<" },
        // { descripcion: "Contiene", valor: "LIKE" },
    ]

    const renderValueComponent = () => {
        const propertyType = format.Prop?.PropertyValue;
        const operator = format.Operator;

        if (operator === "LIKE") {
            return (
                <></>
            );
        }

        switch (propertyType) {
            case "TIPGENERO":
            case "TIPESTADO":
            case "LISTCIVIL":
            case "GRADOSPOL":
            case "TIPOOCU":
                return (
                    <CRSelectorConstants
                        returnType="Object"
                        groupDefinition={propertyType}
                        idSelector={format.Value}
                        label={format.Prop?.Description}
                        onChange={(e) => setFortmat({ ...format, Value: e.IDCreditProperties, renderValue: e.Description })}
                    />
                );

            case "TIPPERSONAGRADE":
                return (
                    <CRSelectorConstants compareKey="PropertyValue" groupDefinition="TIPPERSONAGRADE" idSelector={format.Value} label="Tipo de Persona" returnType="Object" onChange={(e) => setFortmat({ ...format, Value: e.PropertyValue, renderValue: e.Description })} />
                    // <CRSelectorConstants
                    //     returnType="Object"
                    //     groupDefinition={propertyType}
                    //     idSelector={format.Value}
                    //     label={format.Prop?.Description}
                    //     onChange={(e) => setFortmat({ ...format, Value: e.IDCreditProperties, renderValue: e.Description })}
                    // />
                );

            case "CiudadResidenciaIDLn":
                return (
                    <DepartamentCitiesEditor
                        idSelector={format.Value}
                        onChange={(e) => setFortmat({ ...format, Value: e.IDCities, renderValue: e.Ciudad ?? e.Name })}
                        label={format.Prop?.Description}
                    />
                );

            case "INPUT_TEXT":
            default:
                return (
                    <>
                        <label>{format.Prop?.Description ?? "Valor"}</label>
                        <input
                            type="text"
                            className="form-control"
                            value={format.Value}
                            onChange={(e) => setFortmat({ ...format, Value: e.target.value, renderValue: e.target.value })}
                        />
                    </>
                );
        }
    };


    return (
        <div className="row">
            <div className="col-md-12 mb-3">
                <div className="row">
                    <div className="col-md-3">
                        <CRSelectorConstants groupDefinition="TIPEPROPSFILTER" idSelector={format.Prop?.IDCreditProperties} returnType="Object" label="Propiedad" onChange={(e) => {
                            setFortmat({
                                ...format, Prop: {
                                    Description: e.Description,
                                    PropertyValue: e.PropertyValue,
                                    IDCreditProperties: e.IDCreditProperties
                                }
                            })
                        }} />
                    </div>
                    <div className="col-md-3">
                        <label>Operador</label>
                        <select className="form-select" value={format.Operator} onChange={(e) => setFortmat({ ...format, Operator: e.target.value })}>
                            <option value="">...</option>
                            {operators.map((operator, index) => {
                                return (
                                    <option key={index} value={operator.valor}>{operator.descripcion}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="col-md-3">
                        {renderValueComponent()}
                    </div>

                    <div className="col-md-3 d-flex align-items-end">
                        <BasicButton eventClick={create} icon="ri-file-add-line">Agregar</BasicButton>
                    </div>
                </div>
            </div>

            {/* <PrintJson json={lista} /> */}
            <div className="col-md-12">
                <table className="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Propiedad</th>
                            <th>Operador</th>
                            <th>Valor</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lista.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.Prop?.Description}</td>
                                <td>{item.Operator}</td>
                                <td>{item.renderValue}</td>
                                <td>
                                    <BasicButton
                                        eventClick={() => deleteItem(index)}
                                        icon="ri-delete-bin-line"
                                        children="Eliminar"
                                    />
                                </td>
                            </tr>
                        ))}
                        {lista.length === 0 && (
                            <tr>
                                <td colSpan={6} className="text-center">No hay condiciones agregadas</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}